import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ChatAreaAlert from 'conversations-visitor-experience-components/visitor-widget/ChatAreaAlert';
import FilePickerLink from '../../../file-uploads/components/FilePickerLink';
import { INVALID_FILE_TYPE, SIZE_LIMIT_EXCEEDED, UPLOAD_ERROR } from '../../../file-uploads/constants/attachmentErrors';
import { MAX_FILE_SIZE, MAX_FILE_SIZE_PORTAL_53 } from '../../../file-uploads/constants/fileUploadsConstants';
import { EVENT_NAMES } from '../../../usage-tracking/constants/eventNames';
import { getIsPortal53 } from '../../../widget-data/operators/getIsPortal53';
import { getThreadId } from '../../operators/threadGetters';
import { jsx as _jsx } from "react/jsx-runtime";
const AttachmentErrorAlerts = ({
  attachmentsError,
  dismissAttachmentsError: dismiss,
  selectAttachmentFile: select,
  thread,
  trackInteraction
}) => {
  const dismissAttachmentsError = () => {
    dismiss({
      threadId: getThreadId(thread)
    });
  };
  const selectAttachmentFile = ({
    target: {
      files
    }
  }) => {
    if (!files || !files.length) {
      return;
    }
    const file = files.item(0);
    if (file) {
      select({
        file,
        thread
      });
    }
  };
  const trackTryAgain = () => {
    trackInteraction(EVENT_NAMES.WIDGET_INTERACTION, {
      action: 'retry attachment upload'
    });
  };
  const title = (() => {
    switch (attachmentsError) {
      case SIZE_LIMIT_EXCEEDED:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cvVisitorUIAttachments.errors.fileSizeExceeded",
          options: {
            maxSize: I18n.formatSize(getIsPortal53() ? MAX_FILE_SIZE_PORTAL_53 : MAX_FILE_SIZE)
          }
        });
      case UPLOAD_ERROR:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cvVisitorUIAttachments.errors.uploadError"
        });
      case INVALID_FILE_TYPE:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cvVisitorUIAttachments.errors.invalidFileType"
        });
      default:
        return null;
    }
  })();
  return /*#__PURE__*/_jsx(ChatAreaAlert, {
    title: title,
    onClose: dismissAttachmentsError,
    link: /*#__PURE__*/_jsx(FilePickerLink, {
      onChange: selectAttachmentFile,
      onClick: trackTryAgain,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cvVisitorUIAttachments.tryAgain"
      })
    })
  });
};
AttachmentErrorAlerts.displayName = 'AttachmentErrorAlerts';
export default AttachmentErrorAlerts;